export default {
    /* eslint-disable no-eval */
    publicKey: `-----BEGIN PUBLIC KEY-----
    MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAr+IsTWuNqlBibQhAmclM
    2Fk2bJHVEFAH19BB22d22iabK8j97aQZNlkkZHAYZirDWIpkR+/HkSS5z37EJTw6
    F6crLdV7Ulgm7kqargD0ZYTRWygXU706xNsYnsk7D2NeDM/YbBvhL1NuK4FmRt47
    93PA2N5fOOGw85HN6rmhLbrru1eMo8oWscmGhRDvWTrj8yH7Od4oxsQ25ohM86ET
    UF+dlqA9VTCPrc3Aribk4s3EXzqeAUm9HYxkROYkuhsNHVdl1nqVwgwABFmDkJtk
    h7sJFPqLAFBZ2BZQgwOB2yUt8ff/aIIZlUnjjGe1pwW3JROxdKOHaS2ccQnziAJw
    nB2nZyrsLnwrmnGizegvqlHvF9Kxq1NYXzIsHpUIdW1W25F2Vwxfffu2nflAaQA6
    Omz8m/6ERhI7J6o8LwNeszoSQ6OGqbdY8i4s+RfBDQpK46vQ6VKqgFftibVJSGKz
    VTLfqxtw8PNZP39sITP1ZFU6n9efKdJgAYe3xA2cbJgvBdN+akSG9hnS551tBL03
    ORJ7CfzkB0ykzcx8Gir+GCn8l7aea8UopHh9dckJ6F/iF7DOKAeqBo0+OC08g15l
    aC5XwyI1wD6nKAO3+K3BIHoEITspPvf933JzISoTsyVpr8O1Dbz4ub3He8+Gu4Wa
    NY1TZcFsc9IIoNNHKpe/hvkCAwEAAQ==
    -----END PUBLIC KEY-----`
}